/**
 * Derive a user-friendly error message from various error types
 */
export const deriveErrorMessage = (err: unknown, fallback: string): string => {
  if (!err) {
    return fallback;
  }

  if (typeof err === "object" && "status" in err && err.status) {
    const data = (err as { data?: unknown }).data;
    if (typeof data === "string") {
      return data;
    }
    if (
      data &&
      typeof data === "object" &&
      "message" in data &&
      typeof (data as { message?: string }).message === "string"
    ) {
      return (data as { message?: string }).message as string;
    }
    return `Request failed with status ${String(
      (err as { status: number | string }).status,
    )}`;
  }

  if (typeof err === "object" && "message" in err && err.message) {
    return String(err.message);
  }

  return fallback;
};
